<template>
  <v-container fluid class="grey darken-2">
    <v-layout row wrap>
      <v-flex xs12 color="grey" v-if="allSliders.length>0">
        <v-carousel :cycle="cycle" :height="carouselSize">
          <v-carousel-item

                  v-for="(item,i) in allSliders"
                  :key="i"
                  :src="$helper.getLocation()+item.path"
          ></v-carousel-item>
        </v-carousel>
      </v-flex>
      <v-flex xs11 v-for="item,i in allSliders" :key="i" v-show="i === active " class="carousel-nav"
              :class="i === active ? '' : 'hideMe'">
        <h1>
          {{item.headline}}
        </h1>
        <h2>
          {{item.text}}
        </h2>
      </v-flex>
      <v-flex xs1 pa-4 class="cursor-pointer" @click="cycle = !cycle">
        <v-icon v-if="cycle" large color="white" title="pause">pause_circle_outline</v-icon>
        <v-icon v-else="" large color="white" title="play">play_circle_outline</v-icon>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import {mapGetters} from 'vuex';

  let app = document.getElementById('app');
  let nadinsCarousel = document.getElementById('nadinsCarousel');

  export default {
    name: 'ImageSlider',
    computed: {
      ...mapGetters(['allSliders']),
      innerHeight() {
        return isNaN(window.innerHeight) ? window.clientHeight : window.innerHeight;
      },
      innerWidth() {
        return isNaN(window.innerWidth) ? window.clientWidth : window.innerWidth;
      },
      carouselSize() {
        return this.innerHeight > this.innerWidth ? this.innerWidth * 0.5 : this.innerHeight * 0.8;
      },
    },
    data() {
      return {
        msg: 'Welcome to Your Vue.js App',
        activeArr: [false, false, false, false],
        active: 1,
        cycle: true,
      };
    },
    methods: {},
    mounted() {
      setTimeout(()=>{this.active--},500)

    },
  };
</script>
<style>
  .carousel__item {
    transition: 0.8s ease-out;
  }

  .carousel-nav.hideMe {
    opacity: 0;
    color: rgba(2, 1, 32, 0.38);
    height: 0;
  }

  .carousel-nav {
    color: #ffffff;
    text-shadow: black 1px 1px 5px;
    opacity: 100;
    padding: 5px;
    transition: opacity 0.8s ease-out;
  }
</style>
